export const paramsConfig = {
    modals: {
        modals: [],
    },
};
